import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileActionBar from "@/components/feature/MobileActionBar";
import ScrollProgress from "@/components/base/ScrollProgress";
import BackToTop from "@/components/base/BackToTop";
import Hero from "@/pages/home/components/Hero";
import About from "@/pages/home/components/About";
import Offer from "@/pages/home/components/Offer";
import Gallery from "@/pages/home/components/Gallery";
import Rhythm from "@/pages/home/components/Rhythm";
import Gather from "@/pages/home/components/Gather";
import Location from "@/pages/home/components/Location";
import { useRevealObserver } from "@/hooks/useReveal";
import { useHashScroll } from "@/hooks/useHashScroll";

export default function Home() {
  useRevealObserver();
  useHashScroll();

  return (
    <div className="min-h-screen w-full bg-background-100">
      <ScrollProgress />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Offer />
        <Gallery />
        <Rhythm />
        <Gather />
        <Location />
      </main>
      <Footer />
      <MobileActionBar />
      <BackToTop />
    </div>
  );
}